import StyledWrapper from './style';

import { getGNURL } from '../../utils/environmentUtils';

const LoginRedirect = () => {
	const onSubmit = async (e) => {
		e.preventDefault();
		location.replace(getGNURL());
	};

	return (
		<StyledWrapper.LoginPage onSubmit={onSubmit}>
			<div>
				<StyledWrapper.Logo src="/images/logo_2025.svg" alt="Euna Grants Logo" />
				<StyledWrapper.Container>
					<StyledWrapper.Title>Login into Grantmaker Subrecipient Selection</StyledWrapper.Title>
					<StyledWrapper.Subtitle>
						Grantmaker Subrecipient Selection
						<br />
						Alpha version 1.1.0
					</StyledWrapper.Subtitle>

					<StyledWrapper.ButtonContainer>
						<StyledWrapper.PrimaryButton type="submit" variant="contained">
							Go To Grants Network To Login
						</StyledWrapper.PrimaryButton>
					</StyledWrapper.ButtonContainer>
				</StyledWrapper.Container>
			</div>
			<StyledWrapper.SingleSignIn>
				<h6 data-testid={`login-single-sign-on`}>
					To access Grantmaker Subrecipient Selection system, you have to login to Grants Network.
				</h6>
			</StyledWrapper.SingleSignIn>
			<StyledWrapper.GYT src="/images/euna-full-logo.svg" alt="gyt-disclaimer" />
		</StyledWrapper.LoginPage>
	);
};

export default LoginRedirect;
